<template>
  <div class="page">
    <header>
      <NavBar :title="lang('兑换结果')"></NavBar>
    </header>
    <div class="icon">
      <div class="success">
        <img :src="info.img" height="160" width="160" />
        <p class="status">{{ info.status }}</p>
        <p class="msg">{{ info.msg }}</p>
        <van-button
          v-for="(item, i) in btn"
          :key="i"
          round
          plain
          :color="item?.color || ''"
          style="width: 100%; margin-bottom: 22px; font-weight: 500"
          @click="item.fn"
        >
          {{ item.name }}
        </van-button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import NavBar from '@core/components/NavBar.vue'
import lang from '@/langs'
import fail from '@/assets/images/score/fail.png'
import success from '@/assets/images/score/success.png'
import { useRoute, useRouter } from 'vue-router'
const route = useRoute()
const status = route?.query?.status || ''
const router = useRouter()
const successFn = () => {
  return {
    img: success,
    status: lang('兑换成功'),
    msg: lang('可在兑换记录中查看')
  }
}
const failFn = () => {
  return {
    img: fail,
    status: lang('支付失败'),
    msg: route?.query?.msg + lang('兑换失败')
  }
}
const successBtn = () => {
  return [
    {
      fn: () => router.replace('/scoreMain'),
      name: lang('继续兑换'),
      color: 'rgba(59, 171, 137, 1)'
    },
    {
      fn: () => router.replace({ path: '/scoreDetail', query: { type: 0 } }),
      name: lang('去查看')
    }
  ]
}
const failBtn = () => {
  return [
    {
      fn: () => router.replace('/scoreMain'),
      name: lang('查看其他物料商品')
    }
  ]
}
const info = status === 'true' ? successFn() : failFn()
const btn = status === 'true' ? successBtn() : failBtn()
</script>

<style scoped lang="less">
.page {
  height: 100vh;
  width: 100vw;
  background: #fff;
  .icon {
    margin-top: 66px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 17px;
    .success {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      img {
        width: 60px;
        height: 60px;
      }
      .status {
        color: rgba(51, 51, 51, 1);
        font-size: 16px;
        font-weight: 500;
        margin-top: 18px;
      }
      .msg {
        color: rgba(110, 110, 110, 1);
        font-size: 16px;
        font-weight: 400;
        margin-top: 10px;
        margin-bottom: 56px;
      }
    }
  }
}
</style>
